import { Box, Typography } from "@mui/material";
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ClearIcon from '@mui/icons-material/Clear';

export default function StockSummaryCard({ title, value, icon }) {
  const iconMap = {
    "total_stock": <ViewInArIcon sx={{ fontSize: 46 }} />,
    "low_stock_count": <WarningAmberIcon sx={{ fontSize: 46 }} />,
    "out_of_stock_count": <ClearIcon sx={{ fontSize: 46 }} />,
  };

  return (
    <Box
      sx={{
        width: "28%",
        bgcolor: "#d5d8dc",
        borderRadius: "4px",
        display: "flex",
        flexDirection: "row",
        alignContent: "center",
        alignItems: "center",
        gap: 2,
        //justifyContent: "space-between",
        p: 2,
      }}
    >
      {iconMap[icon]}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.6}}>
        <Typography variant="body1">{title}</Typography>
        <Typography variant="h5">{value}</Typography>
      </Box>
    </Box>
  )
}